import React from 'react';
import PropTypes from 'prop-types';

import {withFormsy, propTypes} from "formsy-react";

import {Input} from 'reactstrap'

import prerecordedMessageType from 'constants/prerecordedMessageType';

class PrerecordedMessageItem extends React.Component {
    static propTypes = {
        prerecordedMessage: PropTypes.object.isRequired,
        ...propTypes
    };

    componentWillMount() {
        this.setState({
            active: this.props.value
        });
    }

    changeActive(event) {
        const active = event.target.checked;

        this.props.setValue(active);
        this.setState({
            active
        });
    }

    render() {
        const {prerecordedMessage, name} = this.props;
        const {active} = this.state;

        return (
            <tr>
                <td>{prerecordedMessageType[prerecordedMessage.template] || prerecordedMessage.template}</td>
                <td><Input id={name} name={name} type="checkbox" value={active} checked={active} onChange={::this.changeActive}/></td>
            </tr>
        );
    }
}

export default withFormsy(PrerecordedMessageItem);


// WEBPACK FOOTER //
// ./src/containers/PrerecordedMessages/PrerecordedMessageItem.jsx